import React, { useEffect, useState } from 'react';

import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import 'moment/locale/ko';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useRecoilValue } from 'recoil';
import { authAtom } from '../../_state';
import CommentComponent from '../../components/Board/CommentComponent';
import Backdrop from '@mui/material/Backdrop';
import Divider from '@mui/material/Divider';
import { authUtils } from 'utils/authUtils.js';
import Table from '@mui/material/Table';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import IconButton from '@mui/material/IconButton';
import DownloadIcon from '@mui/icons-material/Download';
import Tooltip from '@mui/material/Tooltip';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';

const columns = [{ id: 'fileName', label: '첨부파일', minWidth: 40, width: 400, align: 'left' }];
export default function Detail() {
  const navigate = useNavigate();
  const location = useLocation();
  const [statusList, setStatusList] = useState([]);
  const [datas, setDatas] = useState({});
  const [status, setStatus] = useState('ING');
  const [open, setOpen] = useState(false);
  const { name, kind, id } = location.state;

  const auth = useRecoilValue(authAtom);
  const modifyBoard = () => {
    navigate('/modify', {
      state: {
        name,
        kind,
        id,
        file: true
      }
    });
  };

  const replyBoard = () => {
    navigate('/reply', {
      state: {
        name,
        kind,
        id,
        file: true
      }
    });
  };

  const getFileName = (contentDisposition) => {
    let fileName = contentDisposition
      .split(';')
      .filter((el) => el.indexOf('filename') > -1)
      .map((ele) => ele.replace(/"/g, '').split('=')[1]);
    return fileName[0];
  };

  const fileDown = async (fileName) => {
    let params = {
      path: `board/${kind.toUpperCase()}/${id}`,
      file: `${fileName}`
    };
    await axios
      .get(`/api/file/${fileName}`, { params, responseType: 'blob' })
      .then((response) => {
        let blob = new Blob([response.data], {
          type: <response className="headers"></response>
        });
        let name = getFileName(decodeURIComponent(response.headers['content-disposition']));
        if (window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, name);
        } else {
          let link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.target = '_self';
          if (name) link.download = name;
          link.click();
          window.URL.revokeObjectURL(link);
        }
      })
      .catch((error) => {
        alert('다운로드 실패!');
      });
  };

  const handleFileDownClick = async (fileName) => {
    await fileDown(fileName);
  };

  const removeBoard = () => {
    axios
      .delete(`/api/board/${kind}/${id}`)
      .then((response) => {
        alert(response.data.message);
        handleBack();
      })
      .catch((error) => {
        alert(error.response.data.message);
      });
  };

  const handleBack = () => {
    navigate('/' + kind.toLowerCase());
  };

  const getBoardDetail = async () => {
    await axios.get(`/api/board/${kind}/${id}`).then(async (response) => {
      await setDatas(response.data);
      if (response.data.kind === 'SECRET') {
        await axios.get(`/api/code/BOARD_STATUS`).then(async (code) => {
          setStatusList(code.data);
          setStatus(response.data.status);
        });
      }
    });
  };

  const handleChangeSelect = async (e) => {
    setStatus(e.target.value);
    await axios.patch(`/api/board/status/${kind}/${id}`, { status: e.target.value }).then(async (response) => {
      alert('상태 변경 완료');
    });
  };

  useEffect(async () => {
    await getBoardDetail();
  }, []);

  return (
    <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
      <Typography component="h2" variant="h6" color="primary" gutterBottom>
        {name}
      </Typography>
      <Grid container spacing={2} position="relative">
        <Grid item xs={12}>
          <Box component="form" noValidate sx={{ mt: 1 }}>
            <TableContainer component={'div'}>
              <Table size="small">
                <TableRow>
                  <TableCell>제목</TableCell>
                  <TableCell>{datas?.subject}</TableCell>
                  <TableCell>작성일</TableCell>
                  <TableCell>{datas?.createdAt}</TableCell>
                </TableRow>
                {kind.toUpperCase() === 'SECRET' && (
                  <TableRow>
                    <TableCell>회사</TableCell>
                    <TableCell>{datas?.companyName}</TableCell>
                    <TableCell>작성자</TableCell>
                    <TableCell>
                      {datas?.username}({datas?.createdId})
                    </TableCell>
                  </TableRow>
                )}
                {kind.toUpperCase() === 'SECRET' && (
                  <TableRow sx={{ display: datas?.parentId !== datas?.id ? 'none' : '' }}>
                    <TableCell>상태</TableCell>
                    <TableCell>
                      {authUtils.useIsAdmin() ? (
                        <>
                          <FormControl sx={{ minWidth: 120 }} size="small">
                            <InputLabel id="status">상태</InputLabel>
                            <Select labelId="status" required id="status" name="status" label="상태" value={status} onChange={handleChangeSelect} size={'small'}>
                              {statusList.length != 0 &&
                                statusList?.map((item, idx) => {
                                  return (
                                    <MenuItem key={`${idx}`} value={item.cdVal}>
                                      <ListItemText primary={item.cdNm} />
                                    </MenuItem>
                                  );
                                })}
                            </Select>
                          </FormControl>
                        </>
                      ) : (
                        datas?.statusNm
                      )}
                    </TableCell>
                  </TableRow>
                )}
              </Table>
            </TableContainer>
            <Box component="div" sx={{ ml: 1, mt: 1, maxHeight: 700 }}>
              <Divider />
              <Box component="div" dangerouslySetInnerHTML={{ __html: datas?.content }} sx={{ minHeight: 400, maxHeight: 700, overflowY: 'scroll' }} />
              <Divider />
            </Box>
            <br />
            {!!datas.files && (
              <Box>
                <TableContainer component={'div'}>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        {columns.map((column) => (
                          <>
                            <TableCell key={column.id} align={column.align} sx={{ minWidth: column.minWidth, width: column.width }}>
                              {column.label}
                            </TableCell>
                            <TableCell></TableCell>
                          </>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {datas.files.map((row, rowIdx) => (
                        <TableRow hover key={row.id}>
                          {columns.map((col, colIdx) => (
                            <>
                              <TableCell key={`row${rowIdx}-col${colIdx}`} align={col.align}>
                                {row[col.id]}
                              </TableCell>
                              <TableCell key={`row${rowIdx}-down`} align="left">
                                <Tooltip title={`파일 다운로드`}>
                                  <IconButton aria-label="down" onClick={(e) => handleFileDownClick(row.realFileName)}>
                                    <DownloadIcon />
                                  </IconButton>
                                </Tooltip>
                              </TableCell>
                            </>
                          ))}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            )}
            {(authUtils.useIsAdmin() || auth.userid === datas.createdId) && (
              <Button sx={{ width: 200, ml: 1 }} variant="contained" onClick={modifyBoard}>
                수정
              </Button>
            )}
            {(authUtils.useIsAdmin() || auth.userid === datas.createdId) && (
              <Button sx={{ width: 200, ml: 1 }} variant="contained" color={'error'} onClick={removeBoard}>
                삭제
              </Button>
            )}
            <Button sx={{ width: 200, ml: 1 }} variant="contained" color={'warning'} onClick={replyBoard}>
              답글
            </Button>
            <Button sx={{ width: 200, ml: 1 }} variant="contained" color="secondary" onClick={handleBack}>
              뒤로
            </Button>
          </Box>
          <br />
          <CommentComponent kind={kind} boardId={id} />
          <Backdrop open={open} />
        </Grid>
      </Grid>
    </Paper>
  );
}
